<template>
  <div class="bg-quickstart-purple p-4 w-full rounded-lg mb-6 border border-gray-200">
    <Card extra-classes="bg-transparent! !bg-transparent !border-0">
      <h1 class="text-2xl font-bold text-white"><slot name="header" /></h1>
      <p class="text-white/80">
        <slot name="body" />
      </p>
    </Card>
  </div>
</template>

<script>
import Card from '../Card/index.vue';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

export default {
  components: {
    Card,
  },
  mounted() {
    setTimeout(() => {
      introJs('#app').addHints();
      introJs('#app').start();
    }, 1000);
  },
};
</script>
